module.exports = __webpack_public_path__ + "img/keypal-color-1.fc5038c1.png";